import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import MapboxTestComponent from '../components/maps/MapboxTestComponent';

const MapboxTestPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Mapbox Integration Test
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          This page tests the Mapbox GL JS integration to ensure the API key is working 
          and basic map functionality is operational.
        </Typography>
        <Button 
          variant="outlined" 
          onClick={() => navigate(-1)}
          sx={{ mb: 2 }}
        >
          ← Back
        </Button>
      </Box>

      <MapboxTestComponent />

      <Box sx={{ mt: 4, p: 2, bgcolor: 'background.paper', borderRadius: 1 }}>
        <Typography variant="h6" gutterBottom>
          Test Checklist:
        </Typography>
        <Typography component="div" variant="body2">
          <ul>
            <li>✓ Mapbox API key is configured</li>
            <li>✓ Map loads without errors</li>
            <li>✓ Map displays street view</li>
            <li>✓ Test marker is visible</li>
            <li>✓ Popup works when clicking marker</li>
            <li>✓ Map is interactive (pan/zoom)</li>
          </ul>
        </Typography>
      </Box>
    </Container>
  );
};

export default MapboxTestPage;